import {Card, CardContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import _ from 'lodash';
import {IFieldValueProps} from '../../utils/models';
import {COLORS} from '@/utils/constants';

interface IOriginTableProps {
    data: IFieldValueProps[],
    total: number,
}

const OriginTable = ({data, total}: IOriginTableProps) => {
    const values = _.orderBy(data.filter(({value}) => value), 'value', 'desc');

    const sum: number = values
        .map(({value}) => value)
        .reduce((partialSum: number, a: number) => partialSum + a, 0);
    const empty = total ? total - sum : 0;

    return (
        <Card className="chart-container">
            <CardContent>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{
                                    fontSize: 18,
                                    backgroundColor: COLORS.pavesiMain,
                                    color: 'white'
                                }}>Paese</TableCell>
                                <TableCell sx={{
                                    fontSize: 18,
                                    backgroundColor: COLORS.pavesiMain,
                                    color: 'white'
                                }}>Beneficiari</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {
                                (empty > 0 && total) && (
                                    <TableRow>
                                        <TableCell/>
                                        <TableCell>{total - sum}</TableCell>
                                    </TableRow>
                                )
                            }
                            {
                                values.map((value, index) => (
                                    <TableRow key={index}>
                                        <TableCell>{value.name}</TableCell>
                                        <TableCell>{value.value}</TableCell>
                                    </TableRow>
                                ))
                            }
                            <TableRow>
                                <TableCell sx={{
                                    fontWeight: 700,
                                    fontSize: 18,
                                    backgroundColor: COLORS.pavesiMain,
                                    color: 'white'
                                }}>
                                    Grand Total
                                </TableCell>
                                <TableCell sx={{
                                    fontWeight: 700,
                                    fontSize: 18,
                                    backgroundColor: COLORS.pavesiMain,
                                    color: 'white'
                                }}>
                                    {total}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </CardContent>
        </Card>
    );
};

export default OriginTable;
